import { render, staticRenderFns } from "./Hermes.vue?vue&type=template&id=5b7f977b&scoped=true&"
import script from "./Hermes.vue?vue&type=script&lang=js&"
export * from "./Hermes.vue?vue&type=script&lang=js&"
import style0 from "./Hermes.vue?vue&type=style&index=0&id=5b7f977b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7f977b",
  null
  
)

export default component.exports